import { duration } from 'moment';

const UPDATE_INTERVAL = duration(1, 'hour');

export default UPDATE_INTERVAL;
